import type { LintResult } from "@ncoder/code-editor";
import type { OpenFile } from "./types";

type CoverageStoreSlice = {
  className: string;
  uncovered_lines: number[];
} | null;

export function buildCoverageMarkers(
  covData: CoverageStoreSlice,
  activeFile: OpenFile | null,
): LintResult[] {
  if (
    !covData ||
    !activeFile ||
    covData.className !== activeFile.name?.replace(/\.(cls|trigger)$/, "")
  ) {
    return [];
  }
  const markers: LintResult[] = [];
  for (const line of covData.uncovered_lines) {
    markers.push({
      line,
      column: 1,
      endLine: line,
      endColumn: 1000,
      message: "Not covered by tests",
      severity: "warning",
    });
  }
  return markers;
}
